import React from 'react';
import { CommonDeleteModal } from 'components';
import { useDeleteModal } from './useDeleteModal';

interface DeleteModal {
  openModal: boolean;
  dataToDelete: Record<string, any> | undefined;
  onDeleteModalClose: (id?: string) => void;
}

export const DeleteModal = (props: DeleteModal) => {
  const { openModal, onDeleteModalClose, dataToDelete } = props;
  const { onRemoveConfirm, contextHolder, isLoading } = useDeleteModal(onDeleteModalClose);
  return (
    <>
      {contextHolder}
      <CommonDeleteModal
        onCancel={() => onDeleteModalClose()}
        open={openModal}
        isLoading={isLoading}
        onOk={() => onRemoveConfirm(dataToDelete)}
        onClose={() => onDeleteModalClose()}
        title={'Delete Task'}
        message={'Are you sure you want to delete this task?'}
      />
    </>
  );
};
